import * as React from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

// Constants
import { ROUTE_PATHS } from '../../constants/routes';

// Services
import {
  INetworkValidateResponse,
  networkValidate,
  networkJoin
} from '../../services/network';

// Types
import { IStore } from '../../store/Store';
import { INavigate } from './NetworksDialog';

type INetwork = INetworkValidateResponse;

// Components
import Button from '../../components/Button';
import { AlertDialog } from '../../components/Dialog';
import Divider from '../../components/Divider';
import Icon from '../../components/Icon';
import MobileStepper from '../../components/MobileStepper';

import FindStep, { FindForm } from './NetworksDialogJoinFind';
import PasswordStep, { PasswordForm } from './NetworksDialogJoinPassword';
import ConfirmStep from './NetworksDialogJoinConfirm';

// Component
interface IProps {
  store?: IStore;
  navigate: INavigate;
  closeDialog: () => void;
}

class AppJoin extends React.Component<IProps, {}> {
  findForm = new FindForm();
  passwordForm = new PasswordForm();

  @observable stepperIndex = 0;

  @observable network: INetwork | null = null;

  @observable
  alertDialogState = {
    open: false,
    title: '',
    description: ''
  };

  handleFindSubmit = async () => {
    this.handleMobileStepperNext();
  };

  @action
  openFindErrorDialog = () => {
    this.alertDialogState = {
      open: true,
      title: 'Network doesn\'t exist',
      description: 'Please try again with another alias or contact support.'
    };
  };

  @action
  openPasswordErrorDialog = () => {
    this.alertDialogState = {
      open: true,
      title: 'Wrong Access-key',
      description:
        'Please try again with another access-key or contact support.'
    };
  };

  @action
  handleDialogClose = () => {
    this.alertDialogState.open = false;
  };

  @action
  handleMobileStepperBack = () => {
    if (this.stepperIndex === 0) {
      this.props.navigate('SELECTOR');
    }
    if (this.stepperIndex === 1) {
      this.stepperIndex -= 1;
    }
    if (this.stepperIndex === 2) {
      if (this.network!.publicAccess === true) {
        this.stepperIndex -= 2;
      } else {
        this.stepperIndex -= 1;
      }
    }
  };

  @action
  handleMobileStepperNext = async () => {
    if (this.stepperIndex === 2) {
      await networkJoin({
        params: { networkId: this.network!.networkId },
        body: { accessKey: this.passwordForm.password.$ }
      });
      this.props.store!.meStore.meInitialize();
      this.props.store!.routerStore.navigate(ROUTE_PATHS.APP_NETWORK, {
        networkId: this.network!.networkId
      });
      this.props.closeDialog();
    }
    if (this.stepperIndex === 1) {
      const validation = await this.passwordForm.state.validate();
      if (validation.hasError === false) {
        try {
          this.network = await networkValidate({
            query: {
              alias: this.findForm.alias.$,
              accessKey: this.passwordForm.password.$
            }
          });
          this.stepperIndex += 1;
        } catch (err) {
          this.openPasswordErrorDialog();
        }
      }
    }
    if (this.stepperIndex === 0) {
      const validation = await this.findForm.state.validate();
      if (validation.hasError === false) {
        try {
          this.network = await networkValidate({
            query: { alias: this.findForm.alias.$ }
          });
          if (this.network.publicAccess === true) {
            this.stepperIndex += 2;
          } else {
            this.stepperIndex += 1;
          }
        } catch (err) {
          this.openFindErrorDialog();
        }
      }
    }
  };

  render() {
    return (
      <div>
        {this.stepperIndex === 0 ? (
          <FindStep form={this.findForm} onSubmit={this.handleFindSubmit} />
        ) : null}
        {this.stepperIndex === 1 ? (
          <PasswordStep
            form={this.passwordForm}
            onSubmit={this.handleFindSubmit}
          />
        ) : null}
        {this.stepperIndex === 2 ? <ConfirmStep /> : null}
        <Divider />
        <MobileStepper
          activeStep={this.stepperIndex}
          type="dots"
          position="static"
          backButton={
            <Button dense={true} onClick={this.handleMobileStepperBack}>
              <Icon>keyboard_arrow_left</Icon>
              Back
            </Button>
          }
          nextButton={
            <Button dense={true} onClick={this.handleMobileStepperNext}>
              {this.stepperIndex === 2 ? 'Join' : 'Next'}
              <Icon>keyboard_arrow_right</Icon>
            </Button>
          }
          steps={3}
        />
        <AlertDialog
          state={this.alertDialogState}
          onClose={this.handleDialogClose}
          onConfirm={this.handleDialogClose}
        />
      </div>
    );
  }
}

export default inject('store')(observer(AppJoin));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/NetworksDialogJoin.tsx